import React, { Component } from "react";
import RugPartsPanelTabs from "./rugPartsPanelTabs";
import RugPartsPanelItems from "./rugPartsPanelItems";
import RugSettingsSidebar from "./rugSettingsSidebar";
import { getLanguageFlag } from "../../languages/languages";
import { supportedLanguages } from "../../settings";
import RugsFilterListSidebar from "./rugsFilterListSidebar";
import { withRouter } from "react-router-dom";


class RugPartsPanel extends Component {
  state = {
    widthPercent: "60%",
    filter: false,
    isPreview: false
  };

  updateWidth = () => {
    const w = window.innerWidth;

    // فرمول خطی: از 60% تا 100% بین 400px و 1600px
    const minW = 400;
    const maxW = 1600;

    // محدود کردن بین min و max
    const clamped = Math.max(minW, Math.min(w, maxW));

    // محاسبه درصد: وقتی w=maxW → 60% ، وقتی w=minW → 100%
    var percent = 60 + ((maxW - clamped) / (maxW - minW)) * 60;
    if(percent > 100) {
      percent = 100;
    }
    this.setState({ widthPercent: `${percent}%` });
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateWidth);
    this.updateWidth(); // initialize on mount
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }

  handleScroll = () => {
    const slider = document.getElementById("partsSlider");

    if (slider.scrollLeft < 600) {
      this.props.itemsScrollHandler();
    }
  };

  handleManualScroll = direction => {
    switch (direction) {
      case "right":
        document.getElementById("partsSlider").scrollLeft -= 120;
        break;
      default:
        document.getElementById("partsSlider").scrollLeft += 120;
        break;
    }

    this.handleScroll()
  };

  filterAction = () => {
    this.setState(prevState => ({
      filter: !prevState.filter
    }));
  };


  render() {
    const { location } = this.props;
    const { widthPercent } = this.state;
    if (location.pathname == '/preview') {
        this.state.isPreview = true;
    }
    return (
      <div className="rug-header" style={{ width: widthPercent }}>
        <div className="rug-header-main">
          <button className="btn-rug btn-rug-right">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10.75H5C2.58 10.75 1.25 9.42 1.25 7V5C1.25 2.58 2.58 1.25 5 1.25H7C9.42 1.25 10.75 2.58 10.75 5V7C10.75 9.42 9.42 10.75 7 10.75ZM5 2.75C3.42 2.75 2.75 3.42 2.75 5V7C2.75 8.58 3.42 9.25 5 9.25H7C8.58 9.25 9.25 8.58 9.25 7V5C9.25 3.42 8.58 2.75 7 2.75H5Z" fill="#353D57" />
              <path d="M19 10.75H17C14.58 10.75 13.25 9.42 13.25 7V5C13.25 2.58 14.58 1.25 17 1.25H19C21.42 1.25 22.75 2.58 22.75 5V7C22.75 9.42 21.42 10.75 19 10.75ZM17 2.75C15.42 2.75 14.75 3.42 14.75 5V7C14.75 8.58 15.42 9.25 17 9.25H19C20.58 9.25 21.25 8.58 21.25 7V5C21.25 3.42 20.58 2.75 19 2.75H17Z" fill="#353D57" />
              <path d="M19 22.75H17C14.58 22.75 13.25 21.42 13.25 19V17C13.25 14.58 14.58 13.25 17 13.25H19C21.42 13.25 22.75 14.58 22.75 17V19C22.75 21.42 21.42 22.75 19 22.75ZM17 14.75C15.42 14.75 14.75 15.42 14.75 17V19C14.75 20.58 15.42 21.25 17 21.25H19C20.58 21.25 21.25 20.58 21.25 19V17C21.25 15.42 20.58 14.75 19 14.75H17Z" fill="#353D57" />
              <path d="M7 22.75H5C2.58 22.75 1.25 21.42 1.25 19V17C1.25 14.58 2.58 13.25 5 13.25H7C9.42 13.25 10.75 14.58 10.75 17V19C10.75 21.42 9.42 22.75 7 22.75ZM5 14.75C3.42 14.75 2.75 15.42 2.75 17V19C2.75 20.58 3.42 21.25 5 21.25H7C8.58 21.25 9.25 20.58 9.25 19V17C9.25 15.42 8.58 14.75 7 14.75H5Z" fill="#353D57" />
            </svg>
            <span>{this.props.texts["menu"]}</span>
          </button>

      
           {!this.state.isPreview && (
                <div>

          <button className="btn-rug btn-rug-left" onClick={this.filterAction}>
            <span>{this.props.texts["filter"]}</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z" fill="#353D57" />
              <path d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z" fill="#353D57" />
              <path d="M14 17.75H10C9.59 17.75 9.25 17.41 9.25 17C9.25 16.59 9.59 16.25 10 16.25H14C14.41 16.25 14.75 16.59 14.75 17C14.75 17.41 14.41 17.75 14 17.75Z" fill="#353D57" />
            </svg>

          </button>

   

          <RugsFilterListSidebar
            showFilter={this.state.filter}
            globalState={this.props.state}
            texts={this.props.texts}
            filterChangeHandler={this.props.filterChangeHandler}
            yarns={this.props.yarns}
            densities={this.props.densities}
            brands={this.props.brands}
            shanehs={this.props.shanehs}
            colors={this.props.colors}
          />
        {this.state.filter && <div className="filter-overlay" onClick={this.filterAction}></div>}
 </div>
          )}



        </div>
      </div>
    );
  }
}

export default withRouter(RugPartsPanel);
